import { connect } from 'react-redux';

import { fullDestinationTextSelector } from 'src/routes/SearchPage/selectors/searchParams';

import {
  getCurrencyCode,
  searchTypeSelector,
  getIsMobile,
} from 'src/store/view/selectors';
import {
  departureCityNameForm2Selector,
  isSearchCompleteSelector,
} from '../../searchStatus/selectors';
import { getMinPrice } from '../../selectors/filters';

import { Title } from './Title';

const mapStateToProps = (state) => ({
  isLoaded: isSearchCompleteSelector(state),
  destinationText: fullDestinationTextSelector(state),
  price: getMinPrice(state),
  currencyCode: getCurrencyCode(state),
  type: searchTypeSelector(state),
  isMobile: getIsMobile(state),
  departureCity: departureCityNameForm2Selector(state),
});

export default connect(mapStateToProps)(Title);
